/**
 * class to structure payment or charge data
 */
import {CustomerCard} from '../CustomerV2Model/customer-v2.model';
import {CardModel} from '../CardModel/card.model';
import {ReviewModel} from '../ReviewModel/review.model';
import {ChargeSplitModel} from '../ChargeSplitModel/charge-split.model';

export class PaymentModel {
  id?: string;
  amount?: number;
  email?: string;
  amount_approved?: number;
  amount_voided?: number;
  sec_code?: string;
  bank_account?: {
    data: {
      first_name: string;
      last_name: string;
      account_number: string;
      routing_number: string;
      account_type: string;
      company_name: string;
      is_default: number;
      last4?: string; } };
  tip_amount?: number;
  amount_captured?: number;
  payarc_fees?: number;
  type?: string;
  net_amount?: number;
  refund_amount?: number;
  gross_sales?: number;
  amount_refunded?: number;
  captured?: number;
  toll_amount?: number;
  status?: string;
  kount_status?: string;
  review?: ReviewModel;
  auth_code?: string;
  under_review?: number;
  failure_code?: string;
  failure_message?: string;
  charge_description?: string;
  invoice?: string;
  created_at?: Date;
  updated_at?: Date;
  refund?: any;
  sales_tax?: number;
  purchase_order?: number;
  supplier_reference_number?: string;
  customer_ref_id?: string;
  ship_to_zip?: number;
  amex_descriptor?: string;
  customer_vat_number?: string;
  summary_commodity_code?: string;
  shipping_charges?: number;
  duty_charges?: number;
  ship_from_zip?: string;
  destination_country_code?: string;
  vat_invoice?: string;
  order_date?: Date;
  tax_category?: string;
  tax_type?: string;
  card_level?: string;
  tax_rate?: number;
  tax_amount?: number;
  airport_fee?: number;
  receipt_phone?: string;
  receipt_email?: string;
  card?: PaymentCard;
  splits?: { data: ChargeSplitModel[] };
  kount_details?: string;
  amex_level3?: any;
  host_transaction_identifier?: string;
  private _paymentObj: any;
  constructor() {
    this.card = new PaymentCard;
    this.review = new ReviewModel;
  }
}

export class PaymentCard {
  data: CardModel;

  constructor() {
    this.data = new CardModel();
  }
}
